module.exports = __webpack_public_path__ + "img/Group-32713-1-1.f92434cc.png";